import {
  CONVERTING,
  COPYING,
  DELETING,
  DELETE_COMPLETE,
  EDITING,
  EXTRACTING,
  FILTERING,
  GLIMPSE_COMPLETE,
  GLIMPSE_ERROR,
  GLIMPSE_QUEUED,
  GLIMPSE_RUNNING,
  NOISE_FILTERING,
  NOISE_FILTERING_COMPLETE,
  NOISE_FILTERING_QUEUED,
  NOISE_FILTER_RUNNING,
  NORMALIZING,
  NORMALIZING_FAILED,
  NORMALIZING_FILTER,
  PROCESSING_FAILED,
  REVERTING,
  SYNC_FILTERING_COMPLETE,
  SYNC_FILTER_RUNNING,
  SYNC_FILTERING_ERROR,
  SYNC_FILTERING_QUEUED,
  TRIMMING,
  UPLOADING,
  UPLOAD_ERROR,
  WAITING_FOR_FILES,
  STOI_QUEUED,
  STOI_RUNNING,
  STOI_COMPLETE,
  ALIGNMENT_QUEUED,
  ALIGNMENT_RUNNING,
  ALIGNMENT_COMPLETE,
  ALIGNMENT_ERROR,
  MERGE_QUEUED,
  MERGE_RUNNING,
  MERGE_ERROR,
  ASI_FILTER_COMPLETE,
  NLMS_FILTER_COMPLETE,
  ASI_FILTER_ERROR,
  NLMS_FILTER_ERROR,
  ASI_FILTER_QUEUED,
  ASI_FILTER_RUNNING,
  NLMS_FILTER_QUEUED,
  NLMS_FILTER_RUNNING,
  BECOMING_SINGLE_CHANNEL,
  STOI_ERROR,
} from "../../../store/statuses";

export const CLIP_PROCESSING_STATUSES = [
  ALIGNMENT_RUNNING,
  ALIGNMENT_QUEUED,
  CONVERTING,
  COPYING,
  EXTRACTING,
  FILTERING,
  GLIMPSE_QUEUED,
  GLIMPSE_RUNNING,
  NOISE_FILTER_RUNNING,
  NOISE_FILTERING_QUEUED,
  NORMALIZING,
  NORMALIZING_FILTER,
  REVERTING,
  STOI_QUEUED,
  STOI_RUNNING,
  SYNC_FILTER_RUNNING,
  TRIMMING,
  UPLOADING,
  MERGE_QUEUED,
  MERGE_RUNNING,
  MERGE_ERROR,
  ASI_FILTER_QUEUED,
  ASI_FILTER_RUNNING,
  NLMS_FILTER_QUEUED,
  NLMS_FILTER_RUNNING,
  BECOMING_SINGLE_CHANNEL,
];

export const NO_FILE_SELECTED_STATUSES = [
  ASI_FILTER_COMPLETE,
  GLIMPSE_COMPLETE,
  NLMS_FILTER_COMPLETE,
];

export const clipStatus = {};

clipStatus[COPYING] = {
  color: "default",
  label: "Copying",
};

clipStatus[DELETING] = {
  color: "default",
  label: "Deleting",
};

clipStatus[DELETE_COMPLETE] = {
  color: "default",
  label: "Delete Complete",
};

clipStatus[EDITING] = {
  color: "info",
  label: "Editing",
};

clipStatus[EXTRACTING] = {
  color: "default",
  label: "Creating Model",
};

clipStatus[FILTERING] = {
  color: "default",
  label: "Filtering",
};

clipStatus[GLIMPSE_COMPLETE] = {
  color: "primary",
  label: "GLIMPSE Complete",
};

clipStatus[GLIMPSE_ERROR] = {
  color: "error",
  label: "GLIMPSE Error",
};

clipStatus[GLIMPSE_QUEUED] = {
  color: "default",
  label: "GLIMPSE Queued",
};

clipStatus[GLIMPSE_RUNNING] = {
  color: "default",
  label: "GLIMPSE Running",
};

clipStatus[NOISE_FILTERING] = {
  color: "default",
  label: "Noise Filtering",
};

clipStatus[NOISE_FILTERING_COMPLETE] = {
  color: "default",
  label: "Noise Filtering Complete",
};

clipStatus[NOISE_FILTERING_QUEUED] = {
  color: "default",
  label: "Noise Filtering Queued",
};

clipStatus[NOISE_FILTER_RUNNING] = {
  color: "default",
  label: "Noise Filtering",
};

clipStatus[NORMALIZING_FILTER] = {
  color: "default",
  label: "Normalizing",
};

clipStatus[NORMALIZING] = {
  color: "default",
  label: "Normalizing",
};

clipStatus[NORMALIZING_FAILED] = {
  color: "error",
  label: "Normalizing Failed",
};

clipStatus[PROCESSING_FAILED] = {
  color: "error",
  label: "Processing Failed",
};

clipStatus[SYNC_FILTERING_QUEUED] = {
  color: "default",
  label: "Sync Filter Queued",
};

clipStatus[SYNC_FILTER_RUNNING] = {
  color: "default",
  label: "Syncing",
};

clipStatus[SYNC_FILTERING_COMPLETE] = {
  color: "default",
  label: "Sync Filter Complete",
};

clipStatus[SYNC_FILTERING_ERROR] = {
  color: "error",
  label: "Sync Filter Error",
};

clipStatus[TRIMMING] = {
  color: "default",
  label: "Trimming",
};

clipStatus[UPLOADING] = {
  color: "default",
  label: "Importing",
};

clipStatus[UPLOAD_ERROR] = {
  color: "error",
  label: "Import Error",
};

clipStatus[WAITING_FOR_FILES] = {
  color: "warning",
  label: "Waiting for Files",
};

clipStatus[CONVERTING] = {
  color: "default",
  label: "Converting",
};

clipStatus[REVERTING] = {
  color: "default",
  label: "Reverting",
};

clipStatus[STOI_QUEUED] = {
  color: "default",
  label: "STOI Queued",
};

clipStatus[STOI_RUNNING] = {
  color: "default",
  label: "STOI Running",
};

clipStatus[STOI_COMPLETE] = {
  color: "default",
  label: "STOI Complete",
};

clipStatus[ALIGNMENT_QUEUED] = {
  color: "default",
  label: "Alignment Queued",
};

clipStatus[ALIGNMENT_RUNNING] = {
  color: "default",
  label: "Alignment Running",
};

clipStatus[ALIGNMENT_COMPLETE] = {
  color: "default",
  label: "Alignment Complete",
};

clipStatus[ALIGNMENT_ERROR] = {
  color: "error",
  label: "Alignment Error",
};

clipStatus[MERGE_QUEUED] = {
  color: "default",
  label: "Merge Queued",
};

clipStatus[MERGE_RUNNING] = {
  color: "default",
  label: "Merging Clips",
};

clipStatus[MERGE_ERROR] = {
  color: "error",
  label: "Merge Error",
};

clipStatus[ASI_FILTER_COMPLETE] = {
  color: "default",
  label: "ASI Complete",
};

clipStatus[NLMS_FILTER_COMPLETE] = {
  color: "default",
  label: "NLMS Complete",
};

clipStatus[ASI_FILTER_ERROR] = {
  color: "error",
  label: "ASI Error",
};

clipStatus[NLMS_FILTER_ERROR] = {
  color: "error",
  label: "NLMS Error",
};

clipStatus[ASI_FILTER_QUEUED] = {
  color: "default",
  label: "ASI Queued",
};

clipStatus[ASI_FILTER_RUNNING] = {
  color: "default",
  label: "ASI Running",
};

clipStatus[NLMS_FILTER_QUEUED] = {
  color: "default",
  label: "NLMS Queued",
};

clipStatus[NLMS_FILTER_RUNNING] = {
  color: "default",
  label: "NLMS Running",
};

clipStatus[BECOMING_SINGLE_CHANNEL] = {
  color: "default",
  label: "Becoming Single Channel",
};

clipStatus[STOI_ERROR] = {
  color: "error",
  label: "STOI ERROR",
};
